import { environment } from "../environments/environment";

/**
 * Whether this viewer gets the Communities hub (web's `/communities` hub, the mobile Community
 * tab's hub mode): everyone while `features.communitiesHub` is on; with it off, employees too
 * when `features.communitiesHubForEmployees` is on — so it can be tried in prod by staff first.
 * `isEmployee` is `UserService.isEmployee` (the verified inhouse group, or the staff address).
 */
export function communitiesHubEnabled(isEmployee: boolean | null | undefined): boolean {
  const features: any = environment.features || {};
  return !!features.communitiesHub || (!!features.communitiesHubForEmployees && !!isEmployee);
}
